import { TrendingUp } from "lucide-react";

function DonutChart() {
  // segments by percentage
  const data = [
    { label: "On Time", v: 87, color: "#22C55E" },
    { label: "At Risk", v: 8, color: "#F97316" },
    { label: "Past Due", v: 5, color: "#EF4444" },
  ];
  // build conic gradient
  let acc = 0;
  const stops = data.map((d) => {
    const start = acc;
    acc += d.v;
    return `${d.color} ${start}% ${acc}%`;
  }).join(", ");

  return (
    <div className="flex items-center gap-5">
      <div
        className="relative h-32 w-32 rounded-full"
        style={{ background: `conic-gradient(${stops})` }}
      >
        <div className="absolute inset-3 rounded-full bg-[#171717] grid place-items-center">
          <div className="text-center">
            <div className="font-mono font-bold text-2xl text-white">87%</div>
            <div className="text-[10px] text-[#94A3B8] tracking-wider">ON TIME</div>
          </div>
        </div>
      </div>
      <div className="space-y-2 text-xs">
        {data.map((d) => (
          <div key={d.label} className="flex items-center gap-2">
            <span className="h-2.5 w-2.5 rounded-sm" style={{ backgroundColor: d.color }} />
            <span className="text-white w-16">{d.label}</span>
            <span className="font-mono text-white">{d.v}%</span>
          </div>
        ))}
      </div>
    </div>
  );
}

function ProductionBars() {
  const DATA = [
    { n: "Marcus T", v: 42 },
    { n: "Jordan R", v: 38 },
    { n: "Sarah K", v: 51 },
    { n: "Devon M", v: 29 },
    { n: "Priya L", v: 44 },
  ];
  const max = 55;
  return (
    <div className="flex items-end gap-3 h-32 mt-2">
      {DATA.map((d) => (
        <div key={d.n} className="flex-1 flex flex-col items-center gap-1.5">
          <div className="font-mono text-[10px] text-white">{d.v}</div>
          <div
            className="w-full rounded-t-md bg-gradient-to-t from-[#FB923C] to-[#F97316]"
            style={{ height: `${(d.v / max) * 100}%` }}
          />
          <div className="text-[10px] text-[#94A3B8] truncate w-full text-center">{d.n.split(" ")[0]}</div>
        </div>
      ))}
    </div>
  );
}

const MARKETS = [
  { m: "Atlanta, GA", open: 84, due: 12, past: 3, sla: "94%" },
  { m: "Nashville, TN", open: 61, due: 8, past: 2, sla: "96%" },
  { m: "Chicago, IL", open: 102, due: 18, past: 7, sla: "88%" },
];

export default function Reporting() {
  return (
    <section data-testid="reporting-section" className="section-y relative">
      <div className="container-x">
        <div className="max-w-4xl reveal mb-12">
          <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#F97316] mb-3">Reporting & Analytics</div>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight">
            Know what happened, where it happened, who handled it, and what still needs attention.
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
          {/* Production */}
          <div className="reveal rounded-2xl glass p-6">
            <div className="flex items-center justify-between mb-3">
              <div className="text-sm font-display font-bold text-white">Production Dashboard</div>
              <TrendingUp size={14} className="text-[#22C55E]" />
            </div>
            <div className="text-[10px] text-[#94A3B8] mb-2 font-mono">TICKETS COMPLETED / WEEK</div>
            <ProductionBars />
          </div>

          {/* SLA */}
          <div className="reveal rounded-2xl glass p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="text-sm font-display font-bold text-white">SLA Compliance</div>
              <span className="status-pill bg-[#22C55E]/15 text-[#22C55E]">ON TRACK</span>
            </div>
            <DonutChart />
          </div>

          {/* Market table */}
          <div className="reveal rounded-2xl glass p-6">
            <div className="flex items-center justify-between mb-3">
              <div className="text-sm font-display font-bold text-white">Market Overview</div>
              <span className="text-[10px] font-mono text-[#94A3B8]">LIVE</span>
            </div>
            <table className="w-full text-xs">
              <thead className="text-[10px] uppercase tracking-wider text-[#94A3B8]">
                <tr className="border-b border-white/5">
                  <th className="text-left py-2 font-medium">Market</th>
                  <th className="text-right py-2 font-medium">Open</th>
                  <th className="text-right py-2 font-medium">Due</th>
                  <th className="text-right py-2 font-medium">Past</th>
                  <th className="text-right py-2 font-medium">SLA</th>
                </tr>
              </thead>
              <tbody className="text-white">
                {MARKETS.map((r) => (
                  <tr key={r.m} className="border-b border-white/5 last:border-0">
                    <td className="py-2.5">{r.m}</td>
                    <td className="py-2.5 text-right font-mono">{r.open}</td>
                    <td className="py-2.5 text-right font-mono text-[#F97316]">{r.due}</td>
                    <td className="py-2.5 text-right font-mono text-[#EF4444]">{r.past}</td>
                    <td className="py-2.5 text-right font-mono text-[#22C55E]">{r.sla}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}
